"use client";

import { useEffect } from "react";
import ReactLenis from "lenis/react";

import { useGoogleOff } from "@/hooks/useGoogleOff";
import { initAxe } from "@/utils/initAxe";

export default function RootLayoutClient({
  // Layouts must accept a children prop.
  // This will be populated with nested layouts or pages
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    initAxe().catch((error) => {
      console.error(error);
    });
  }, []);

  // comment this out to enable google crawling for NEXT_DATA
  useGoogleOff("__NEXT_DATA__");

  function updateScrollbarWidth() {
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty(
      "--scrollbar-width",
      `${scrollbarWidth}px`,
    );
  }

  useEffect(() => {
    window.addEventListener("resize", updateScrollbarWidth);
    updateScrollbarWidth();
    return () => {
      window.removeEventListener("resize", updateScrollbarWidth);
    };
  }, []);

  return (
    <ReactLenis
      options={{
        lerp: /*pageTransition*/ false ? 0 : 0.1,
      }}
      className="wrapper"

      root
    >
      {children}
    </ReactLenis>
  );
}
